import React from 'react';
import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/hook';
import getDateWithTimeZone from 'helpers/getDateWithTimeZone';
import classes from './DraftSelectionModal.module.scss';
import { getTheme } from 'helpers/getTheme';
import cn from 'classnames';

type DraftSelectionModalProps = {
  open: boolean;
  onSelectDraft: () => void;
  onSelectOriginal: () => void;
  onCancel: () => void;
  lastModified: string | null;
};

const DraftSelectionModal: React.FC<DraftSelectionModalProps> = ({
  open,
  onSelectDraft,
  onSelectOriginal,
  onCancel,
  lastModified,
}) => {
  const { t } = useTranslation();
  const { userData } = useAppSelector((state) => state.userData);

  return (
    <Modal
      open={open}
      title={t('Documents.details.editTab.draft_modal_title')}
      onCancel={onCancel}
      footer={null}
      // closable={false}
      // maskClosable={false}
      className={cn(classes.modal, getTheme())}
      centered
	    width={500}
    >
      <div className={classes.content}>
        <p className={classes.message}>
          {t('Documents.details.editTab.draft_modal_message1')}
		      <br />
          {t('Documents.details.editTab.draft_modal_message2')}
        </p>
        {lastModified && (
          <p className={classes.lastModified}>
            {t('Documents.details.editTab.draft_last_modified')} {getDateWithTimeZone(lastModified, userData?.date_format || 'international')}
          </p>
        )}
        <div className={classes.buttons}>
          <Button
            type='primary'
            className={classes.draftButton}
            onClick={onSelectDraft}
            size='large'
          >
            {t('Documents.details.editTab.continue_draft')}
          </Button>
          <Button
            className={classes.originalButton}
            onClick={onSelectOriginal}
            size='large'
          >
            {t('Documents.details.editTab.edit_original')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DraftSelectionModal;

